/* i18n-ignore: interne adminpagina, alleen NL */
import { createFileRoute } from "@tanstack/react-router";
import { AdminNav } from "@/components/admin/AdminNav";
import { MediaOrganiser } from "@/components/admin/media-organise/MediaOrganiser";

export const Route = createFileRoute("/_authenticated/admin/foto-ordenen")({
  staticData: { sitemap: false },
  head: () => ({
    meta: [{ title: "Foto's — Gopro Projects" }, { name: "robots", content: "noindex" }],
  }),
  component: AdminOrganisePage,
});

function AdminOrganisePage() {
  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-10 sm:px-6">
      <AdminNav />
      <div className="mb-6 mt-4">
        <h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl">Foto's</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Laad foto's op, orden ze volgens het merkboek en beheer ze: categorieën, tags, brandpunt, toestemming, volgorde en prullenbak.
        </p>
      </div>
      <MediaOrganiser />
    </main>
  );
}
